import { createSlice } from '@reduxjs/toolkit';
import ProductModel from '../../components/model/ProductModel';

const ProductSlice = createSlice({
    name: 'product',
    initialState: ProductModel,
    reducers: {
        setProductObj(state, { payload }) {
            state.name = payload.name;
            state.uuid = payload.uuid;
            state.proteins = payload.proteins;
            state.fat = payload.fat;
            state.carbohydrates = payload.carbohydrates;
            state.energyValueKcal = payload.energyValueKcal;
            state.water = payload.water;
            state.dryMaterial = payload.dryMaterial;
            state.vegetableProtein = payload.vegetableProtein;
            state.mineralSubstances = payload.mineralSubstances;
            state.sodium = payload.sodium;
            state.magnesium = payload.magnesium;
            state.phosphorus = payload.phosphorus;
            state.potassium = payload.potassium;
            state.calcium = payload.calcium;
            state.iodine = payload.iodine;
            state.vitaminB2 = payload.vitaminB2;
            state.niacinVitaminPP = payload.niacinVitaminPP;
            state.niacinEquivalent = payload.niacinEquivalent;
            state.vitaminB6 = payload.vitaminB6;
            state.alcohol = payload.alcohol;
            state.energyKj = payload.energyKj;
            state.iron = payload.iron;
            state.vitaminB1 = payload.vitaminB1;
            state.zinc = payload.zinc;
            state.saturatedFattyAcids = payload.saturatedFattyAcids;
            state.monounsaturatedFattyAcids = payload.monounsaturatedFattyAcids;
            state.polyunsaturatedFattyAcids = payload.polyunsaturatedFattyAcids;
            state.starch = payload.starch;
            state.fiberMaterials = payload.fiberMaterials;
            state.selenium = payload.selenium;
            state.vitaminARetinol = payload.vitaminARetinol;
            state.vitaminETocopherol = payload.vitaminETocopherol;
            state.folicAcid = payload.folicAcid;
            state.vitaminC = payload.vitaminC;
            state.animalProtein = payload.animalProtein;
            state.cholesterol = payload.cholesterol;
            state.vitaminD = payload.vitaminD;
            state.vitaminB12 = payload.vitaminB12;
            state.sugar = payload.sugar;
        },
    },
});

export default ProductSlice.reducer;
export const { setProductObj } = ProductSlice.actions;
